import { RTL_OFFSET_POS_DESC, RTL_OFFSET_NAG, RTL_OFFSET_POS_ASC } from '../../config'

export function initRowStyleCache() {
  return ({
    rowHeight,
    highlight
  }) => {
    const style = {}
    if (highlight) {
      style.backgroundColor = 'var(--g-table-row-highlight-bg)'
    }
    return style
  }
}

export function getRowClassName({ highlight }) {
  const className = []
  if (highlight) {
    className.push('highlight')
  }
  return className
}

let cachedRTLResult = null
export function getRTLOffsetType(recalculate = false) {
  if (cachedRTLResult === null || recalculate) {
    const outerDiv = document.createElement('div')
    const outerStyle = outerDiv.style
    outerStyle.width = '50px'
    outerStyle.height = '50px'
    outerStyle.overflow = 'scroll'
    outerStyle.direction = 'rtl'

    const innerDiv = document.createElement('div')
    const innerStyle = innerDiv.style
    innerStyle.width = '100px'
    innerStyle.height = '100px'

    outerDiv.appendChild(innerDiv)

    document.body.appendChild(outerDiv)

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = RTL_OFFSET_POS_DESC
    } else {
      outerDiv.scrollLeft = 1
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = RTL_OFFSET_NAG
      } else {
        cachedRTLResult = RTL_OFFSET_POS_ASC
      }
    }

    document.body.removeChild(outerDiv)

    return cachedRTLResult
  }

  return cachedRTLResult
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/virtual-grid/utils.js